
import { XMLValidator } from 'fast-xml-parser';

export const useSitemapComparison = () => {
  /**
   * Validate XML structure for well-formedness
   */
  const validateXmlStructure = (xmlContent: string): { isValid: boolean; error?: string } => {
    if (!xmlContent) {
      return { isValid: false, error: 'Empty content' };
    }

    // Check for XML declaration
    if (!xmlContent.trim().startsWith('<?xml')) {
      console.warn('XML content does not start with XML declaration');
    }

    // Validate XML structure
    const result = XMLValidator.validate(xmlContent, {
      allowBooleanAttributes: true,
    });

    if (result !== true) {
      return { 
        isValid: false, 
        error: result.err?.msg || 'Invalid XML structure'
      };
    }

    // Check for basic sitemap elements
    if (!xmlContent.includes('<urlset') || !xmlContent.includes('</urlset>')) {
      return { isValid: false, error: 'Missing urlset element' };
    }

    return { isValid: true };
  };

  /**
   * Compare two sitemaps to see if they are equivalent
   * Returns true if they match, false otherwise
   */
  const compareSitemapContents = (sitemapA: string, sitemapB: string): boolean => {
    if (!sitemapA || !sitemapB) {
      console.log('One or both sitemaps are empty');
      return false;
    }
    
    try {
      // Clean and normalize both XML documents
      const cleanA = sitemapA.trim().replace(/\s+/g, ' ');
      const cleanB = sitemapB.trim().replace(/\s+/g, ' ');
      
      // Basic structure validation
      const validA = validateXmlStructure(cleanA);
      const validB = validateXmlStructure(cleanB);
      
      if (!validA.isValid || !validB.isValid) {
        console.warn('One or both sitemaps have invalid structure');
        return false;
      }
      
      // Count URLs in each sitemap
      const urlCountA = (cleanA.match(/<url>/g) || []).length;
      const urlCountB = (cleanB.match(/<url>/g) || []).length;
      
      if (urlCountA !== urlCountB) {
        console.log(`URL count mismatch: Domain has ${urlCountA}, Storage has ${urlCountB}`);
        return false;
      }
      
      // For a more comprehensive check, you'd need to parse the XML and compare URL by URL
      // For now, this is a good enough check
      console.log(`Both sitemaps have ${urlCountA} URLs`);
      return true;
    } catch (error) {
      console.error('Error comparing sitemaps:', error);
      return false;
    }
  };

  return {
    validateXmlStructure,
    compareSitemapContents
  };
};
